<div>
  <app-header *ngIf="visibleHeader"></app-header>
  <div class="container mt-5">

    <!-- Informações Participante -->
    <div class="card-participant d-flex flex-column align-items-center full-width mb-4">

      <!-- titulo -->
      <h2 class="title mb-4">Documentos para declaração do IR</h2>

      <!-- Dados do usuário -->
      <div class="info-participant mb-3">
        <div class="detalhe">
          <p *ngIf="!isDepSaude">Nome: {{ nomeExibicao }}</p>
          <p>CPF: {{ cpfExibicao }}</p>
          <p>Ano de referência: {{ lastYear }}</p>
          <p>Ano de exercício: {{ currentYear }}</p>
        </div>

        <button *ngIf="isAtendente()" class="btn-attendant" type="button" (click)="sendEmail()">
          Enviar Email
        </button>
      </div>

      <!-- Texto informativo -->
      <div>
        <app-informative-text>
        </app-informative-text>
      </div>
    </div>

    <!-- Previdência -->
    <div class="mb-5">

      <h2 class="title-info mb-5">Documentos de Previdência</h2>

      <app-informative-no-result *ngIf="
            !cardsVisible[cardType.INFORME_RENDIMENTOS] &&
            !cardsVisible[cardType.INFORME_CONTRIBUICAO] &&
            !cardsVisible[cardType.INFORME_FAMILINVEST] &&
            !cardsVisible[cardType.INFORME_FORD] &&
            !cardsVisible[cardType.INFORME_ROCHEPREV]">
        <p class="no-result-text">Não foram encontrados documentos relacionados à previdência.</p>
      </app-informative-no-result>


      <div class="container-card d-flex">
        <!-- cards Previdencia -->
        <app-card *ngIf="cardsVisible[cardType.INFORME_RENDIMENTOS]" class="cards" title="Informe de Rendimentos"
          buttonLabel="Baixar PDF" [download]="true" (action)="handleCard($event)"
          [cardType]="cardType.INFORME_RENDIMENTOS">
        </app-card>
        <app-card *ngIf="cardsVisible[cardType.INFORME_CONTRIBUICAO]" class="cards" title="Informe de Contribuições"
          buttonLabel="Baixar PDF" [download]="true" (action)="handleCard($event)"
          [cardType]="cardType.INFORME_CONTRIBUICAO">
        </app-card>
        <app-card *ngIf="cardsVisible[cardType.INFORME_FAMILINVEST]" class="cards"
          title="Documentos do Plano Familinvest" buttonLabel="Acessar Portal" [direction]="true"
          (action)="handleCard($event)" [cardType]="cardType.INFORME_FAMILINVEST" [isApp]="isApp">
        </app-card>
        <app-card *ngIf="cardsVisible[cardType.INFORME_FORD]" class="cards" title="Documentos do Plano Ford"
          buttonLabel="Acessar Portal" [direction]="true" (action)="handleCard($event)"
          [cardType]="cardType.INFORME_FORD" [isApp]="isApp">
        </app-card>
        <app-card *ngIf="cardsVisible[cardType.INFORME_ROCHEPREV]" class="cards" title="Documentos do Plano RochePrev"
          buttonLabel="Acessar Portal" [direction]="true" (action)="handleCard($event)"
          [cardType]="cardType.INFORME_ROCHEPREV" [isApp]="isApp">
        </app-card>
      </div>
    </div>

    <!-- Saúde -->
    <div class="mb-5">

      <h2 class="title-info mb-5">Documentos de Saúde</h2>

      <app-informative-no-result *ngIf="!cardsVisible[cardType.EXTRATO_SAUDE]">
        <p class="no-result-text">Não foram localizados documentos na sua matrícula.</p>
        <p class="no-result-text">Verifique no Portal de Serviços da Saúde em relatórios > Demonstrativo Anual de Despesas e Reembolso</p>
        <button class="btn-no-result btn" (click)="redirectLoginFacil()">Acessar o Portal da Saúde</button>
      </app-informative-no-result>

      <div class="container-card d-flex">
        <!-- cards Saúde -->
        <app-card *ngIf="cardsVisible[cardType.EXTRATO_SAUDE]" class="cards" title="Extrato Anual de Saúde"
          buttonLabel="Baixar PDF" [download]="true" (action)="handleCard($event)" [cardType]="cardType.EXTRATO_SAUDE">
        </app-card>
      </div>
    </div>
  </div>
</div>

<app-modal [title]="'Documentos para declaração do IR'" [isOpen]="isModalOpen" (close)="closeModal()">

  <div class="d-flex flex-column gap-4 mb-4">
    <p class="title-modal d-flex">Aviso de Redirecionamento</p>

    <p class="description-modal">Você será redirecionado para um portal externo para acessar o documento solicitado.
    </p>
  </div>

  <div class="content-button d-flex justify-content-center gap-3">
    <button class="btn cancel" (click)="closeModal()">Cancelar</button>
    <button class="btn continue" (click)="onRedirect()">Continuar</button>
  </div>

</app-modal>
